<template>
	<div class="mt-4">
		<div class="d-block text-right w-100 py-3 mb-3 font-size-11 secondary--text darken-3">
			Ditampilkan <b>{{ serialSupremeList.length }}</b> Serial dari <b>{{ serialSupremePagination.total_data }}</b> Serial Supreme yang tersedia.
		</div>

		<v-row class="body-transaction-product body-transaction-product-sm">
			<v-col cols="12" class="pb-0">
				<template v-if="!loading">
					<template v-if="serialSupremeList.length > 0">
						<v-row class="ml-0">
							<v-col cols="12" sm="6" md="3" xl="3" class="pl-0 pb-0" v-for="(serial, i) in serialSupremeList" :key="i">
								<v-card class="pa-3 elevation-0 rounded-xl hover-shadow" :class="serial_params.serial_id.includes(serial.serial_id) ? 'selected' : ''">
									<!--  @click="checkSerial(serial, serial.serial_id)" -->
									<v-row>
										<!-- <v-col cols="2" sm="2" md="2" class="my-auto">
											<v-checkbox hide-details class="mt-0 pt-0 mr-0" on-icon="mdi-check-circle" off-icon="mdi-checkbox-blank-circle-outline" v-model="serial.checked" @click="checkSerial(serial, serial.serial_id)"></v-checkbox>
										</v-col> -->
										<v-col cols="12" sm="12" md="12" class="my-auto">
											<div class="d-flex flex-wrap">
												<v-col cols="12" md="12" class="pa-0 d-flex flex-row align-center justify-space-between">
													<div class="font-size-10 cl-grey d-flex alkign-center"><v-icon dense color="grey" class="mr-2">mdi-barcode-scan</v-icon> Serial</div>
													<div class="font-size-10 font-size-xs-11 cl-primary font-weight-600">{{ serial.serial_id }}</div>
												</v-col>
												<v-col cols="12" md="12" class="px-0 pt-1 pb-0 d-flex flex-row align-center justify-space-between" v-if="false">
													<div class="font-size-10 cl-grey">Tipe</div>
													<div class="font-size-10 cl-grey font-weight-600">{{ serial.serial_member_serial_type_name }}</div>
												</v-col>
											</div>
										</v-col>
									</v-row>
								</v-card>
							</v-col>
						</v-row>
						<div class="my-5 pt-5">
							<v-row justify="center">
								<template>
									<v-col cols="9" sm="4" md="3" xl="2" class="pb-0" v-if="serialSupremePagination.total_page > 1 && serialSupremePagination.next > 0">
										<v-btn block large outlined class="bg-white rounded-xl" color="dark" :loading="btn_load_more" :disabled="btn_load_more" @click="loadMore">
											<v-icon>mdi-sync-circle</v-icon>
											<span class="pl-2">Muat Lebih Banyak</span>
										</v-btn>
									</v-col>
								</template>
							</v-row>
						</div>
					</template>
					<template v-else>
						<v-row>
							<v-col cols="12" sm="12" md="12">
								<v-card class="py-3 elevation-0 hover-shadow rounded-xl">
									<NoData></NoData>
									<div class="pt-3 text-center cl-secondary">Tidak ada data serial yang dapat ditampilkan</div>
								</v-card>
							</v-col>
						</v-row>
					</template>
				</template>
				<template v-if="loading">
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<LoadData :loading="loading"></LoadData>
						</v-col>
					</v-row>
				</template>
			</v-col>
		</v-row>
		<div class="footer-transaction-product rounded-xl">
			<div class="d-flex flex-wrap">
				<v-col cols="12" sm="6" class="pa-0 my-auto">
					<div class="font-size-11 product-name"><b>{{ serial_params.serial_id.length }}</b> Serial Supreme dipilih</div>
				</v-col>
				<v-col cols="12" sm="6" class="d-none d-md-block pb-0 px-0 pa-sm-0 text-right my-auto">
					<v-btn large width="140" depressed color="primary" class="rounded-xl" :disabled="!network_code || serial_params.serial_id.length == 0" :loading="btn_loading" @click="showConfirm">
						<v-icon>mdi-arrow-right</v-icon>
						<span class="pl-2">Kirim</span>
					</v-btn>
				</v-col>

				<v-col cols="12" sm="6" class="d-flex d-md-none align-center justify-space-between pb-0 px-0 pa-sm-0 text-right my-auto">
					<v-btn large width="140" depressed color="primary" class="d-flex flex-grow-1 flex-shrink-1 mx-1 rounded-xl" :disabled="!network_code || serial_params.serial_id.length == 0" :loading="btn_loading" @click="showConfirm">
						<v-icon>mdi-arrow-right</v-icon>
						<span class="pl-2">Kirim</span>
					</v-btn>
				</v-col>
			</div>
		</div>
		<ModalKonfirm ref="modalKonfirm" :network_code="network_code" :nama_mitra="nama_mitra" :serialqty="parseInt(serialqty)" serialtype="Supreme" @action="processSend"></ModalKonfirm>
		<ModalGagal ref="modalGagal" :msg="msg_failed"></ModalGagal>
		<ModalSukses ref="modalSukses" network_code="network_code" :nama_mitra="nama_mitra" :successResponse="successResponse" :serialqty="parseInt(serialqty)" serialtype="Supreme" @action="resetData"></ModalSukses>
		<ModalOTP ref="modalOTP" @action="executeSerialSending"></ModalOTP>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalKonfirm from './components/ModalKonfirm';
import ModalGagal from '@/components/modals/vo-general/ModalGagal';
import ModalSukses from './components/ModalSukses';
import ModalOTP from './components/ModalOTP';

export default {
	components: {
		ModalKonfirm, ModalGagal, ModalSukses, ModalOTP
	},
	props: {
		network_code: String,
		nama_mitra: String,
		serialqty: Number
	},
	watch: {
		serialqty(val) {
			if (Object.keys(this.serialSupremePagination).length > 0 && val <= this.serialSupremePagination.total_data) {
				if (val > this.limit) {
					this.limit = val
					this.getData()
				}

				setTimeout(() => {
					this.getSelectedSerial()
				}, 500)
			} else {
				this.loading = true
				setTimeout(() => {
					this.serial_params.serial_id = []
					this.loading = false
				}, 1300)
			}
		}
	},
	data() {
		return {
			btn_load_more: false,
			loading: false,
			btn_loading: false,
			page: 1,
			limit: '20',
			params: [],
			serial_params: {
				member_network_code: '',
				serial_id: [],
				otp: ''
			},
			msg_failed: "Mohon Maaf kirim serial Anda Gagal. Silakan ulangi kembali proses kirim serial",
		}
	},
	computed: {
		...mapState('serial', ['serialSupremeList', 'serialSupremePagination']),
		...mapState(['successResponse']),
	},
	methods: {
		...mapActions('serial', ['getSerialSupremeList', 'getLoadSerialSupremeList', 'sendSerial']),

		getData() {
			this.loading = true
			this.page = 1
			if ((this.serialqty > this.limit)) this.limit = this.serialqty
			this.getSerialSupremeList(this.queryString({limit:this.limit, page: this.page, params: this.params, sort: 'serial_buy_datetime', dir: 'asc'}))
			.then(() => {
				this.getSelectedSerial()
				this.$emit('loadtab', this.serialSupremePagination.total_data)
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
				this.loading = false
			}).catch(() => {
				this.loading = false
			})
		},
		getSelectedSerial() {
			if (this.serialSupremeList.length > 0) {
				if (this.serialqty > 0 && this.serialqty <= this.serialSupremePagination.total_data) {
					this.serial_params.serial_id = []
					for (let x = 0; x < this.serialqty; x++) {
						this.serial_params.serial_id.push(this.serialSupremeList[x].serial_id)
					}
				} else {
					this.serial_params.serial_id = []
				}
			} else {
				this.serial_params.serial_id = []
			}
		},
		loadMore() {
			this.btn_load_more = true
			this.page += 1
			this.getLoadSerialSupremeList(this.queryString({limit:this.limit, page: this.page, params: this.params, sort: 'serial_buy_datetime', dir: 'asc'}))
			.then(() => {
				this.btn_load_more = false
			})
		},
		checkSerial(serial, id) {
			if (serial.checked) {
				serial.checked = false
			} else {
				serial.checked = true
			}

			if (serial.checked == true) {
				this.serial_params.serial_id.push(id)
			} else {
				this.serial_params.serial_id = this.serial_params.serial_id.filter(function(item) {
					return item !== id
				})
			}
		},
		showConfirm() {
			this.$refs.modalKonfirm.modalShow()
		},
		processSend() {
			this.serial_params.member_network_code = this.network_code
			// this.$refs.modalKonfirm.loadingButton()
			this.$refs.modalKonfirm.modalHide()
			this.$refs.modalOTP.modalShow()
		},
		executeSerialSending(otpcode) {
			this.$refs.modalOTP.loadingButton()
			this.serial_params.otp = otpcode
			this.sendSerial(this.serial_params).then(() => {
				this.$refs.modalOTP.loadingButton()
				this.getData()
				this.serial_params.serial_id = []
				// this.$refs.modalKonfirm.normalButton()
				this.$refs.modalOTP.modalHide()
				this.$refs.modalKonfirm.modalHide()
				this.$refs.modalSukses.modalShow()
				// this.$emit('action')
			}).catch(() => {
				this.$refs.modalOTP.modalHide()
				this.$refs.modalKonfirm.normalButton()
				this.$refs.modalKonfirm.modalHide()
				this.$refs.modalGagal.modalShow()
			})
		},

		resetData() {
			this.$emit('action')
		}
	},
	created(){
		this.$store.dispatch('setPageTitle', `Kirim Serial`)
		this.getData()
	},
};
</script>

<style lang="scss" scoped>
	.selected {
		background: rgb(197 144 66 / 10%)!important;
	}
</style>